"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _rsManagement = require("@/api/rsManagement");
var _systemSetting = require("@/api/systemSetting");
var _customerOrderApi = require("@/api/customerOrderApi");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var createEmptyStoreType = function createEmptyStoreType() {
  return {
    id: null,
    name: '',
    icon: '',
    sort: 0,
    pageDisplayType: 0,
    relatedCustomerType: 1,
    customerIds: []
  };
};
var _default2 = exports.default = {
  name: 'BusinessTypeDialog',
  props: {
    allTreeData: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      visible: false,
      loading: false,
      customerOptions: [],
      customerLoading: false,
      pageDisplayTypeOptions: [],
      pageDisplayTypeLoading: false,
      formData: {
        id: null,
        type: null,
        storeTypes: [createEmptyStoreType()]
      },
      rules: {
        type: [{
          required: true,
          message: '请选择业务类型',
          trigger: 'change'
        }]
      },
      originalData: null // 保存原始传入的数据
    };
  },
  created: function created() {
    this.loadPageDisplayTypeOptions().catch(function () {});
  },
  computed: {
    isEditMode: function isEditMode() {
      return !!this.formData.id;
    },
    isGroupBuyType: function isGroupBuyType() {
      return Number(this.formData.type) === 2;
    }
  },
  watch: {
    'formData.type': function formDataType(newVal) {
      if (newVal) {
        this.loadStoreTypesByType(newVal);
      }
    }
  },
  methods: {
    loadPageDisplayTypeOptions: function () {
      var _loadPageDisplayTypeOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var list;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.pageDisplayTypeLoading = true;
              _context.p = 1;
              _context.n = 2;
              return (0, _rsManagement.getPageDisplayTypeList)();
            case 2:
              list = _context.v;
              this.pageDisplayTypeOptions = (list || []).map(function (item) {
                return {
                  value: Number(item.key),
                  label: item.value
                };
              });
            case 3:
              _context.p = 3;
              this.pageDisplayTypeLoading = false;
              return _context.f(3);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1,, 3, 4]]);
      }));
      function loadPageDisplayTypeOptions() {
        return _loadPageDisplayTypeOptions.apply(this, arguments);
      }
      return loadPageDisplayTypeOptions;
    }(),
    open: function open() {
      var _this = this;
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // 保存原始数据
      this.originalData = data;
      this.searchCustomerOptions('');
      if (data.id || data.type) {
        // 编辑模式：回显数据
        var storeTypes = [];
        if (data.storeTypes && Array.isArray(data.storeTypes)) {
          storeTypes = data.storeTypes.map(function (item) {
            return _this.mapStoreTypeItem(item);
          });
        } else if (data.name || data.icon) {
          storeTypes = [this.mapStoreTypeItem(data)];
        } else {
          storeTypes = [createEmptyStoreType()];
        }
        this.formData = {
          id: data.id || null,
          type: data.type || null,
          storeTypes: storeTypes.length > 0 ? storeTypes : [createEmptyStoreType()]
        };
      } else {
        this.formData = {
          id: null,
          type: null,
          storeTypes: [createEmptyStoreType()]
        };
      }
      this.mergeAllCustomerOptionsFromStoreTypes();
      this.visible = true;
      this.$nextTick(function () {
        if (_this.$refs.form) {
          _this.$refs.form.clearValidate();
        }
      });
    },
    handleTypeChange: function handleTypeChange(type) {
      // 当选择店铺类型后，从树形数据中获取该type下已有的店铺类型数据
      if (type) {
        this.loadStoreTypesByType(type);
      } else {
        this.formData.storeTypes = [createEmptyStoreType()];
      }
      this.normalizePageDisplayTypes();
    },
    mapStoreTypeItem: function mapStoreTypeItem() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return {
        id: item.id || null,
        name: item.name || '',
        icon: item.icon || '',
        sort: item.sort !== undefined ? item.sort : 0,
        pageDisplayType: this.parsePageDisplayType(item),
        relatedCustomerType: this.parseRelatedCustomerType(item),
        customerIds: this.parseCustomerIds(item),
        customerList: item.customerList || item.applyCustomerList || []
      };
    },
    parsePageDisplayType: function parsePageDisplayType() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var pageDisplayType = Number(data.pageDisplayType);
      if (Number.isNaN(pageDisplayType)) return 0;
      var validValues = this.pageDisplayTypeOptions.map(function (item) {
        return item.value;
      });
      return validValues.length === 0 || validValues.includes(pageDisplayType) ? pageDisplayType : 0;
    },
    parseRelatedCustomerType: function parseRelatedCustomerType() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var rawType = data.relatedCustomerType;
      if (rawType != null && rawType !== '' && !Number.isNaN(Number(rawType))) {
        return Number(rawType) === 1 ? 1 : 0;
      }
      if (Array.isArray(data.customerIds) && data.customerIds.length) {
        return 0;
      }
      return 1;
    },
    parseCustomerIds: function parseCustomerIds() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (this.parseRelatedCustomerType(data) !== 0) {
        return [];
      }
      if (!Array.isArray(data.customerIds)) {
        return [];
      }
      return data.customerIds.map(function (id) {
        return Number(id);
      }).filter(function (id) {
        return !Number.isNaN(id);
      });
    },
    searchCustomerOptions: function () {
      var _searchCustomerOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(keyword) {
        var res, byId, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.customerLoading = true;
              _context2.p = 1;
              _context2.n = 2;
              return (0, _customerOrderApi.companyappAutoListApi)({
                keyword: keyword
              });
            case 2:
              res = _context2.v;
              byId = new Map((this.customerOptions || []).map(function (item) {
                return [Number(item.customerId), item];
              }));
              (res || []).forEach(function (item) {
                var customerId = Number(item.customerId);
                if (!Number.isNaN(customerId)) {
                  byId.set(customerId, item);
                }
              });
              this.customerOptions = Array.from(byId.values());
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              console.warn('获取小程序客户列表失败:', _t.message);
            case 4:
              _context2.p = 4;
              this.customerLoading = false;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3, 4, 5]]);
      }));
      function searchCustomerOptions(_x) {
        return _searchCustomerOptions.apply(this, arguments);
      }
      return searchCustomerOptions;
    }(),
    mergeAllCustomerOptionsFromStoreTypes: function mergeAllCustomerOptionsFromStoreTypes() {
      var byId = new Map((this.customerOptions || []).map(function (item) {
        return [Number(item.customerId), item];
      }));
      (this.formData.storeTypes || []).forEach(function (item) {
        var namedList = item.customerList || item.applyCustomerList || [];
        if (Array.isArray(namedList) && namedList.length) {
          namedList.forEach(function (row) {
            var customerId = Number(row.customerId != null ? row.customerId : row.id);
            if (Number.isNaN(customerId)) return;
            byId.set(customerId, {
              customerId: customerId,
              appName: row.appName || row.name || row.customerName || "\u5BA2\u6237 ".concat(customerId)
            });
          });
        } else if (Array.isArray(item.customerIds)) {
          item.customerIds.forEach(function (id) {
            var customerId = Number(id);
            if (Number.isNaN(customerId) || byId.has(customerId)) return;
            byId.set(customerId, {
              customerId: customerId,
              appName: "\u5BA2\u6237 ".concat(customerId)
            });
          });
        }
      });
      this.customerOptions = Array.from(byId.values());
    },
    onStoreRelatedCustomerTypeChange: function onStoreRelatedCustomerTypeChange(index, val) {
      var _this2 = this;
      if (Number(val) === 1) {
        this.formData.storeTypes[index].customerIds = [];
      }
      this.$nextTick(function () {
        if (_this2.$refs.form) {
          _this2.$refs.form.clearValidate(["storeTypes.".concat(index, ".customerIds")]);
        }
      });
    },
    getCustomerIdsRules: function getCustomerIdsRules(index) {
      var _this3 = this;
      return [{
        validator: function validator(rule, value, callback) {
          var item = _this3.formData.storeTypes[index];
          if (Number(item.relatedCustomerType) === 0) {
            if (!value || !value.length) {
              callback(new Error('请选择关联小程序'));
              return;
            }
          }
          callback();
        },
        trigger: 'change'
      }];
    },
    loadStoreTypesByType: function loadStoreTypesByType(type) {
      var _this4 = this;
      // 从树形数据中查找对应type的店铺类型数据
      // 优先使用 props 传入的 allTreeData，其次使用 originalData.allData
      var allTreeData = this.allTreeData && this.allTreeData.length > 0 ? this.allTreeData : this.originalData && this.originalData.allData || [];
      var parentNode = allTreeData.find(function (node) {
        return node.type === type && node.isParent;
      });
      if (parentNode && parentNode.children && parentNode.children.length > 0) {
        this.formData.storeTypes = parentNode.children.map(function (item) {
          return _this4.mapStoreTypeItem(item);
        });
      } else {
        this.formData.storeTypes = [createEmptyStoreType()];
      }
      this.normalizePageDisplayTypes();
      this.mergeAllCustomerOptionsFromStoreTypes();
      // 触发验证
      this.$nextTick(function () {
        if (_this4.$refs.form) {
          _this4.$refs.form.clearValidate();
        }
      });
    },
    handleAddStoreType: function handleAddStoreType() {
      this.formData.storeTypes.push(createEmptyStoreType());
    },
    normalizePageDisplayTypes: function normalizePageDisplayTypes() {
      if (this.isGroupBuyType) return;
      (this.formData.storeTypes || []).forEach(function (item) {
        item.pageDisplayType = 0;
      });
    },
    handleRemoveStoreType: function handleRemoveStoreType(index) {
      var _this5 = this;
      if (this.formData.storeTypes.length > 1) {
        this.formData.storeTypes.splice(index, 1);
        this.$nextTick(function () {
          if (_this5.$refs.form) {
            _this5.$refs.form.clearValidate();
          }
        });
      } else {
        this.$message.warning('至少需要保留一个店铺类型');
      }
    },
    beforeUpload: function beforeUpload(file) {
      var isImage = file.type.startsWith('image/');
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
        return false;
      }
      return true;
    },
    handleUpload: function handleUpload(param, index) {
      var _this6 = this;
      var formData = new FormData();
      formData.append('multipart', param.file);
      var data = {
        model: 'businessType',
        pid: 0
      };
      var loading = this.$loading({
        lock: true,
        text: '上传中，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      (0, _systemSetting.fileImageApi)(formData, data).then(function (res) {
        loading.close();
        _this6.formData.storeTypes[index].icon = res.url || res.attDir || res.sattDir;
        _this6.$message.success('上传成功');
        // 触发验证
        if (_this6.$refs.form) {
          _this6.$refs.form.validateField("storeTypes.".concat(index, ".icon"));
        }
      }).catch(function () {
        loading.close();
        _this6.$message.error('上传失败');
      });
    },
    handleRemoveImage: function handleRemoveImage(index) {
      this.formData.storeTypes[index].icon = '';
      if (this.$refs.form) {
        this.$refs.form.validateField("storeTypes.".concat(index, ".icon"));
      }
    },
    handleSubmit: function handleSubmit() {
      var _this7 = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) return;
        if (_this7.isGroupBuyType && _this7.pageDisplayTypeOptions.length === 0) {
          _this7.$message.warning('页面展示类型尚未加载完成，请稍后重试');
          return;
        }

        // 验证至少有一个店铺类型
        if (!_this7.formData.storeTypes || _this7.formData.storeTypes.length === 0) {
          _this7.$message.warning('请至少添加一个店铺类型');
          return;
        }

        // 验证每个店铺类型都有完整数据
        var hasEmpty = _this7.formData.storeTypes.some(function (item) {
          if (!item.name || !item.icon) return true;
          if (Number(item.relatedCustomerType) === 0 && (!item.customerIds || !item.customerIds.length)) {
            return true;
          }
          return false;
        });
        if (hasEmpty) {
          _this7.$message.warning('请完善所有店铺类型信息');
          return;
        }
        _this7.loading = true;
        var merchantStoreTypeList = _this7.formData.storeTypes.map(function (item) {
          var relatedCustomerType = Number(item.relatedCustomerType) === 1 ? 1 : 0;
          var validPageDisplayTypes = _this7.pageDisplayTypeOptions.map(function (option) {
            return option.value;
          });
          var pageDisplayType = _this7.isGroupBuyType && validPageDisplayTypes.includes(Number(item.pageDisplayType)) ? Number(item.pageDisplayType) : 0;
          var obj = {
            type: _this7.formData.type,
            name: item.name,
            icon: item.icon,
            sort: item.sort !== undefined ? item.sort : 0,
            pageDisplayType: pageDisplayType,
            relatedCustomerType: relatedCustomerType,
            customerIds: relatedCustomerType === 0 && item.customerIds && item.customerIds.length ? item.customerIds.map(function (id) {
              return Number(id);
            }) : []
          };
          // 编辑时，如果 storeTypes 中有 id，则带上 id
          if (item.id) {
            obj.id = item.id;
          }
          return obj;
        });
        var params = {
          merchantStoreTypeList: merchantStoreTypeList
        };
        (0, _rsManagement.saveOrUpdateBusinessType)(params).then(function () {
          _this7.$message.success('操作成功');
          _this7.loading = false;
          _this7.visible = false;
          _this7.$emit('refresh');
        }).catch(function () {
          _this7.loading = false;
        });
      });
    },
    closeDialog: function closeDialog() {
      this.visible = false;
    }
  }
};